export type ProductType = 'osago' | 'kasko' | 'pkasko' | 'pkasko_standalone' | 'dkasko' | 'accident' | 'mortgage';

export const PRODUCT_LABELS: Record<ProductType, string> = {
  osago: 'ОСАГО',
  kasko: 'КАСКО',
  pkasko: 'ПКАСКО',
  pkasko_standalone: 'ПКАСКО (standalone)',
  dkasko: 'ДКАСКО',
  accident: 'Несчастный случай',
  mortgage: 'Ипотека',
};

export const PRODUCTS: Array<{ value: ProductType; label: string }> = [
  { value: 'osago', label: PRODUCT_LABELS.osago },
  { value: 'kasko', label: PRODUCT_LABELS.kasko },
  { value: 'pkasko', label: PRODUCT_LABELS.pkasko },
  { value: 'pkasko_standalone', label: PRODUCT_LABELS.pkasko_standalone },
  { value: 'mortgage', label: PRODUCT_LABELS.mortgage },
  // { value: 'dkasko', label: PRODUCT_LABELS.dkasko },
  // { value: 'accident', label: PRODUCT_LABELS.accident },
];
